module.exports = __webpack_public_path__ + "img/827b464.png";